import SearchInput from 'components/SearchInput';
import { TableFilterRow } from 'components/TableList';

import { search_expense_code_text } from '../constants';
import { IExpenseCodesFiltersProps } from '../types';

export const ExpenseCodeFilters = ({
  onPageChange,
  params
}: IExpenseCodesFiltersProps): JSX.Element => {
  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  return (
    <TableFilterRow>
      <SearchInput
        value={(params.search as string) || ''}
        onSearch={handleSearch}
        placeholder={search_expense_code_text}
      />
    </TableFilterRow>
  );
};
